import { Grid } from '@mui/material';
import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TabsComponent from '#app/Component/TabsComponent';
import TitleComponent from '#app/Component/TitleComponent';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import DisputeList from '#app/View/Sale/Client/SaleClient/components/DisputeList';
import OrderClientList from '#app/View/Sale/Client/SaleClient/components/OrderClientList';
import SaleCreateClientForm from '#app/View/Sale/Client/SaleClient/components/SaleCreateClientForm';
import useClient from '#app/View/Sale/Client/SaleClient/hooks/useClient';

export type Client = {
  uuid: string;
  number: string;
  firstname: string;
  lastname: string;
  zipCode: string;
  email: string;
  phone: string;
  country: number;
  optinSms?: boolean;
  optinEmail?: boolean;
};
const SaleClient: React.FC = () => {
  const { client, loading } = useClient();

  return (
    <ContentViewComponent
      loading={loading}
      breadcrumbs={{
        title: 'Fiche client',
        context: 'Vente',
        links: [{ path: getRoutePathname('sale_client_list'), label: 'Liste des clients' }],
      }}
    >
      {client && (
        <>
          <ShadowBoxComponent style={{ height: '100%' }}>
            <TitleComponent title="Information client" />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <p style={{ fontSize: 14, margin: 2 }}>
                  <span style={{ fontWeight: 700 }}>Référence</span> : {client.number}
                </p>
                <p style={{ fontSize: 14, margin: 2 }}>
                  <span style={{ fontWeight: 700 }}>Nom du client</span> : {client.lastname}
                </p>
                <p style={{ fontSize: 14, margin: 2 }}>
                  <span style={{ fontWeight: 700 }}>Prénom du client</span> : {client.firstname}
                </p>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <p style={{ fontSize: 14, margin: 2 }}>
                  <span style={{ fontWeight: 700 }}>Email du client</span> : {client.email}
                </p>
                <p style={{ fontSize: 14, margin: 2 }}>
                  <span style={{ fontWeight: 700 }}>Téléphone du client</span> : {client.phone}
                </p>
                <p style={{ fontSize: 14, margin: 2 }}>
                  <span style={{ fontWeight: 700 }}>Code postal du client</span> : {client.zipCode}
                </p>
              </Grid>
            </Grid>
          </ShadowBoxComponent>

          <br />
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <SaleCreateClientForm client={client} />
            </Grid>
          </Grid>
          <br />

          <TabsComponent
            tabDefault="sale_client_order_client_list"
            tabs={[
              { key: 'sale_client_order_client_list', label: 'Commandes' },
              { key: 'sale_client_litige_list', label: 'Litiges' },
            ]}
          >
            <OrderClientList key="sale_client_order_client_list" />
            <DisputeList key="sale_client_litige_list" />
          </TabsComponent>
        </>
      )}
    </ContentViewComponent>
  );
};

export default SaleClient;
